import React, { useState } from 'react';
import { Drawer } from '@material-ui/core';
import styles from './DrawerPage.module.css';
import Logo from '../../assets/Logo/RePack_logo_text_transparent.png';
import { useHistory, useLocation } from 'react-router-dom';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import TimelineIcon from '@material-ui/icons/Timeline';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import TranslateIcon from '@material-ui/icons/Translate';
import MailIcon from '@material-ui/icons/Mail';
import PeopleIcon from '@material-ui/icons/People';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import SidebarItem from './SidebarPageItem';
import { userActions } from '../../redux/actions';

function Sidebar({ variant, open, onClose }) {
  const isUserRepack = useSelector((state) => state.userReducer.isUserRepack);
  const [displayedLanguage, setDisplayedLanguage] = useState('eng');
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const location = useLocation();

  const navigateTo = (path) => {
    history.push(path);
  };

  const signOut = () => {
    dispatch(userActions.setUserRepack(false));
    dispatch(userActions.logOut());
    navigateTo('/login');
  };

  const toggleLanguage = () => {
    const otherLanguage = displayedLanguage === 'eng' ? 'nor' : 'eng';
    setDisplayedLanguage(otherLanguage);
    i18n.changeLanguage(otherLanguage);
  };

  const sendMail = () => {
    window.open('mailto:contact@repack.no');
  };

  const pages = [
    {
      title: t('systems'),
      onlyForRePack: false,
      path: '/systems',
      icon: <FormatListBulletedIcon />
    },
    {
      title: t('modules'),
      onlyForRePack: true,
      path: '/modulelibrary',
      icon: <ViewModuleIcon />
    },
    {
      title: t('analytics'),
      onlyForRePack: true,
      path: '/analytics',
      icon: <TimelineIcon />
    },
    {
      title: t('users'),
      onlyForRePack: true,
      path: '/users',
      icon: <PeopleIcon />
    }
  ];

  return (
    <Drawer
      classes={{
        paper: styles.paper
      }}
      variant={variant}
      anchor={'left'}
      open={open}
      onClose={onClose}
    >
      <div className={styles.drawer}>
        <div
          className={styles.logoContainer}
          role={'button'}
          tabIndex={0}
          onClick={() => navigateTo('/systems')}
          onKeyDown={() => navigateTo('/systems')}
        >
          <img className={styles.logo} src={Logo} alt={'RePacks logo'} />
        </div>
        <div className={styles.sidebarItemsContainer}>
          <div className={styles.sidebarPageItemsContainer}>
            {pages.map((page) => {
              if (!isUserRepack && page.onlyForRePack) {
                return null;
              }
              return (
                <SidebarItem
                  selected={page.path === location.pathname}
                  key={page.title}
                  title={page.title}
                  onClick={() => navigateTo(page.path)}
                  icon={page.icon}
                />
              );
            })}
          </div>
          <div className={styles.sidebarSecondaryItemsContainer}>
            <SidebarItem
              title={t('contact')}
              icon={<MailIcon />}
              onClick={sendMail}
            />
            <SidebarItem
              title={
                t('use') +
                ' ' +
                (displayedLanguage === 'eng'
                  ? t('LanguageNor')
                  : t('LanguageEng'))
              }
              icon={<TranslateIcon />}
              onClick={toggleLanguage}
            />
            <SidebarItem
              title={t('signOut')}
              onClick={signOut}
              icon={<ExitToAppIcon />}
            />
          </div>
        </div>
      </div>
    </Drawer>
  );
}

export default Sidebar;
